import FCellBtnMDP from "@/components/table/cell/FCellBtnMDP";
import FCellDateTimeMDP from "@/components/table/cell/FCellDateTimeMDP";
import FCellPhoneMDP from "@/components/table/cell/FCellPhoneMDP";
import FDataTableMDP from "@/components/table/FDataTableMDP";

export default class VerifiedClientListFDataTableMDP extends FDataTableMDP{
  parent: any;
  constructor(props: { parent: any }) {
    super({
      myRefName: "verifiedClientListFDataTableRef",
      enableSearch: true,
      title: "Partner Client File List",
      enableShowHideColumns: true,
      itemKey: "partnerId",
    });
    this.parent = props.parent;
    this.addClientFileNumberColumn({ dataSelectorKey: "clientFileNumber" })
      .addColumn({
        label: "Client Name",
        dataSelectorKey: "clientFullName",
        columnCellMDP: new FCellBtnMDP({
          onClick: (item) => {},
          color: "purple",
        }),
      })
      .addClientFileStatusColumn({
        label: "Status",
        dataSelectorKey: "status.name",
      })
      .addColumn({
        label: "Mobile",
        dataSelectorKey: "clientBasicInfo.mobile",
        columnCellMDP: new FCellPhoneMDP()
      })
      .addColumn({
        label: "City",
        dataSelectorKey: "city",
      })
      .addColumn({
        label: "Created On",
        dataSelectorKey: "createdOn",
        columnCellMDP: new FCellDateTimeMDP(),
      })
      .addColumn({
        label: "Credit Score",
        dataSelectorKey: "creditScore",
      })
      .addColumn({
        label: "WAD",
        dataSelectorKey: "wad",
      })
      .addCurrencyColumn({
        label: "Unsecured Loan Amount",
        dataSelectorKey: "unsecuredLoanAmount",
      })
      .addColumn({
        label: "Assigned Sales Rep",
        dataSelectorKey: "assignedSalesRep",
      });
  }
}
